import { AttachmentType } from '@issuemanager/constants';
import { z } from 'zod';
import { minimalUserSchema } from './user';

// Represents the attachment table schema 1-to-1 mapping with database columns
export const actionAttachmentsTableSchema = z.object({
  attachment_id: z.string(),
  action_id: z.string(),
  created_at: z.string().transform((date) => new Date(date)),
  attachment_type: z
    .enum([
      AttachmentType.APPROVAL,
      AttachmentType.ATTACHMENT,
      AttachmentType.DECLINATION,
    ])
    .optional(),
});

export const actionAttachmentSchemaTransformed = z.object({
  attachmentId: z.string(),
  actionId: z.string(),
  createdAt: z.string().transform((date) => new Date(date)),
  attachmentType: z.enum([
    AttachmentType.APPROVAL,
    AttachmentType.ATTACHMENT,
    AttachmentType.DECLINATION,
  ]),
});

export const actionAttachmentQueryResponseSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    hb_drive_id: z.string(),
    size: z.number(),
    created_at: z.string().transform((date) => new Date(date)),
    added_by: minimalUserSchema,
    attachment_type: z.enum([
      AttachmentType.APPROVAL,
      AttachmentType.ATTACHMENT,
      AttachmentType.DECLINATION,
    ]),
  })
  .transform((attachment) => ({
    id: attachment.id,
    name: attachment.name,
    size: attachment.size,
    hbDriveId: attachment.hb_drive_id,
    createdAt: attachment.created_at,
    addedBy: attachment.added_by,
    attachmentType: attachment.attachment_type,
  }));
export type ActionAttachmentQueryResponseType = z.infer<
  typeof actionAttachmentQueryResponseSchema
>;
